import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchContent = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/content");
      setContent(data);
    } finally {
      setLoading(false);
    }
  }, []);

  const saveContent = async (next) => {
    const { data } = await api.put("/content", {
      sections: next.sections,
      branding: next.branding,
      nav: next.nav || null,
    });
    setContent(data);
    return data;
  };

  useEffect(() => { fetchContent(); }, [fetchContent]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh: fetchContent, saveContent, setContent }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
